<script setup lang="ts">
/**
 * Which element the settings below are for, with what is done to it whole.
 *
 * The list of elements is in another tab, so the settings say whose they are:
 * its kind and its words or name, and the two things done to an element as a
 * whole, duplicating it and taking it off the page.
 */
import { useI18n } from 'vue-i18n'

defineProps<{
  kind: string
  label: string
}>()

const emit = defineEmits<{ duplicate: []; remove: [] }>()

const { t } = useI18n()
</script>

<template>
  <div class="current">
    <span class="current__kind">{{ kind }}</span>
    <span class="current__label">{{ label }}</span>
    <span class="current__ops">
      <button
        type="button"
        class="b-icon-btn"
        :title="t('inspector.layer.duplicate')"
        :aria-label="t('inspector.layer.duplicate')"
        @click="emit('duplicate')"
      >
        <svg width="12" height="12" viewBox="0 0 16 16" aria-hidden="true">
          <path
            d="M5.5 5.5h8v8h-8z M2.5 10.5v-8h8"
            fill="none"
            stroke="currentColor"
            stroke-width="1.25"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <button
        type="button"
        class="b-icon-btn b-btn--danger"
        :title="t('inspector.layer.remove')"
        :aria-label="t('inspector.layer.remove')"
        @click="emit('remove')"
      >
        <svg width="12" height="12" viewBox="0 0 16 16" aria-hidden="true">
          <path
            d="M3 4.5h10 M5.5 4.5V3h5v1.5 M4.5 4.5l.6 8.5h5.8l.6-8.5"
            fill="none"
            stroke="currentColor"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </span>
  </div>
</template>

<style scoped>
.current {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  padding: var(--sp-2) var(--sp-2) var(--sp-2) var(--sp-4);
  border-radius: var(--radius);
  background: var(--accent-quiet);
}

.current__kind {
  flex: none;
  color: var(--accent);
  font-size: var(--text-xs);
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.current__label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  color: var(--ink);
  font-size: var(--text-sm);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.current__ops {
  flex: none;
  display: flex;
  gap: 1px;
}
</style>
